module.exports = __webpack_public_path__ + "img/d1.b801e39f.png";